const Template = `<div class="modem-info-window">
<div class='user-info'>
<table >

  <tr>
    <td class='label'>{{$t('users.login')}}</td>
    <td class='value'>
      <input class="input-dark" type='text' v-model=user.name :readonly="(mode=='view')||(mode=='edit')" > 
      <div v-if="mode!='view'"><div class="red" v-if="(!user.name)">{{$t('users.enterLogin')}}</div></div><br>
    </td>
  </tr>
    <tr>
    <td class='label' valign="top">{{$t('users.password')}}<br>
    

    </td>
    <td class='value'>
      <input class="input-dark" type='text' v-model=user.password1 :readonly="mode=='view'" > 
      <div v-if="mode=='edit'"><div v-if="((!user.password1)&&(!user.password2))">{{$t('users.unchanged')}}</div></div>
      <div v-if="mode=='create'"><div class="red" v-if="((!user.password1)||(!user.password2))">{{$t('users.enterPassword')}}</div></div><br>
      <input class="input-dark" type='text' v-model=user.password2 :readonly="mode=='view'" > <div class="red" v-if="(user.password1!=user.password2)">{{$t('users.dontMatch')}}</div>
    </td>
  </tr>
  <tr>
    <td class='label'>{{$t('users.email')}}</td>
    <td class='value'>
      <input class="input-dark" type='email' v-model=user.email :readonly="mode=='view'"> 
      <div v-if="mode!='view'"><div class="red" v-if="!(user.email.indexOf('@') > -1)">{{$t('users.incorrectEmail')}}</div></div><br>
    </td>
  </tr>
  <tr>
    <td class='label' valign="top">{{$t('users.group')}}</td>
    <td class='value'>

      <input type="radio" id="two" value="user" v-model="user.group"  :disabled="mode=='view'">
      <label for="two" v-bind:class="{ bold: user.group=='user' }">{{$t('users.user')}}</label>
      <br>
      <input type="radio"  id="one" value="admin" v-model="user.group"  :disabled="mode=='view'">
      <label for="one" v-bind:class="{ bold: user.group=='admin' }">{{$t('users.admin')}}</label>
    </td>
  </tr>
  <tr>
    <td class='label'>{{$t('users.phone')}}</td>
    <td class='value'>
      <input class="input-dark" type='tel' v-model=user.phone :readonly="mode=='view'"> 
      <div v-if="mode!='view'"><div class="red" v-if="user.phone!=parseInt(user.phone)">{{$t('users.phoneFormat')}}</div></div>
      
    </td>
  </tr>
  <tr>
    <td class='label'>{{$t('users.checkbox1')}}</td>
    <td class='value'>
      <input class="input-dark" type='checkbox' v-model=user.notification1 :readonly="mode=='view'"> 
    </td>
  </tr>
  <tr>
    <td class='label'>{{$t('users.checkbox2')}}</td>
    <td class='value'>
      <input class="input-dark" type='checkbox' v-model=user.notification2 :readonly="mode=='view'"> 
    </td>
  </tr>
  
</table>
<button class="input-dark" v-on:click="edit" v-show="mode=='view'">{{$t('users.edit')}}</button>
<button class="input-dark" v-on:click="create" v-show="mode=='view'">{{$t('users.create')}}</button>
<button class="input-dark" v-on:click="del" v-show="(mode=='view')&&(user.name!='admin')">{{$t('users.delete')}}</button>
<button class="input-dark" v-on:click="save" v-show="(mode=='edit')||(mode=='create')">{{$t('users.save')}}</button>
<button class="input-dark" v-on:click="cancel" v-show="(mode=='edit')||(mode=='create')">{{$t('users.cancel')}}</button>

</div> 
</div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page3_users/info_window/template.js